import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';
import { PREFIX_ROUTES } from '../util/path';
import RouteNumber from './RouteNumber';

export default function RouteHeader(props) {
  const mode = props.route.mode.toLowerCase();

  const trip = props.trip ? (
    <span className="route-header-trip">
      {props.trip.substring(0, 2)}:{props.trip.substring(2, 4)} →
    </span>
  ) : (
    ''
  );

  const routeLineText = ` ${props.route.shortName || ''}`;

  const routeLine =
    props.trip && props.pattern ? (
      <Link
        to={`/${PREFIX_ROUTES}/${props.route.gtfsId}/pysakit/${
          props.pattern.code
        }`}
      >
        {routeLineText}
      </Link>
    ) : (
      routeLineText
    );

  return (
    <div className={cx('route-header', props.className)}>
      <h2 className={mode}>
        <RouteNumber mode={mode} text={routeLine} />
        {trip}
      </h2>
    </div>
  );
}

RouteHeader.propTypes = {
  route: PropTypes.shape({
    gtfsId: PropTypes.string.isRequired,
    mode: PropTypes.string.isRequired,
    shortName: PropTypes.string,
  }).isRequired,
  trip: PropTypes.string,
  pattern: PropTypes.shape({ code: PropTypes.string.isRequired }),
  className: PropTypes.string,
};
